import React from "react";
import { dispatch } from "@rematch/core";
import { withRouter } from "react-router-dom";
import { Form } from "formsy-semantic-ui-react";
import AddSystemNotificationModal from './../Drive/SystemNotification/AddSystemNotificationModal'
import EditSystemNotificationModal from './../Drive/SystemNotification/EditSystemNotificationModal'
import DeleteSystemNotificationModal from './../Drive/SystemNotification/DeleteSystemNotificationModal'
import MomentDate from "../../../common/MomentDate";
import MomentDateAndTime from "../../../../helpers/momentDateAndTime";
import Labels from "../../../common/Labels";
import { List, Card, Dropdown, Image, Container, Header, Button, Label, Textarea, Loader, Icon } from "semantic-ui-react";
import axios from "axios";
import { singleLineText, singleLinePassword, } from "../../../common/RegexValidation";
import _ from "lodash";
import { systemNotification } from "../../../../state/models";

// changes made for KLM-8917 KLM-8921
class SystemNotification extends React.Component {

  constructor(props) {
    super(props);
    this.openEditSysNotification = this.openEditSysNotification.bind(this);
    this.openDeleteSysNotification = this.openDeleteSysNotification.bind(this);

    this.state = {
      notificationList: null,
      selectedNotification: null,
      isAddSystemNotificationModalOpen: false,
      isEditSystemNotificationModalOpen: false,
      isDeleteSystemNotificationModalOpen: false
    }
  }

  getSystemNotification = (e) => {
    dispatch.account.setState();
  }

  createSystemNotification = (e) => {
    dispatch.account.setAddSystemNotificationModal(true);
  }

  editSystemNotification = (e) => {
    dispatch.account.setEditSystemNotificationModal(true);
  }

  deleteSystemNotification = (e) => {
    dispatch.account.setDeleteSystemNotificationModal(true);
  }
  
  componentWillMount() {
    dispatch.systemNotification.getSystemNotification();
    
    if (this.props.selectedNotification=== null) {
      if (this.props.match.params.notificationId) {
        dispatch.notification.setSelectedNotification(
          this.props.match.params.notificationId
        );
      }
    }
    // dispatch.integrations.getAllIssueList('myself')
  }

  componentWillReceiveProps(newProps) {
    // if (this.props.isAddSystemNotificationModalOpen !== newProps.isAddSystemNotificationModalOpen) {
    //     this.setState({ isAddSystemNotificationModalOpen: newProps.isAddSystemNotificationModalOpen })
    // }
  }

  openAddSysNotification = (e) => {
    this.setState({isAddSystemNotificationModalOpen: true })
	}

  openEditSysNotification = (e, _id) => {
    e.preventDefault();
    console.log("Open modal - Edit System");
    this.setState({isEditSystemNotificationModalOpen: true, selectedNotification: _id });
  }

  openDeleteSysNotification = (e, selectedNotification) => {
    e.preventDefault();
    console.log("Open Delete modal");
    this.setState({isDeleteSystemNotificationModalOpen: true, selectedNotification: selectedNotification })
	}

  render() {
    const notificationListData = this.props.allSystemNotificationList? this.props.allSystemNotificationList.data.filter((count) => new Date(count.expDate)>=new Date()) : [];
    const notificationCount = this.props.allSystemNotificationList? this.props.allSystemNotificationList.data.filter((count) => new Date(count.expDate)>=new Date()).length: "";
    console.log("all SystemNotification List *", this.props.allSystemNotificationList);
  //  debugger;
  //  const editSystemNotification = this.props.allSystemNotificationList.data? this.props.allSystemNotificationList.data.filter((item)=>{ return item.title == 'test'} ): [];

    const { notificationList } = this.state;
    const { selectedNotification } = this.state;
    const { isAddSystemNotificationModalOpen } = this.state;
    const { isEditSystemNotificationModalOpen } = this.state;
    const { isDeleteSystemNotificationModalOpen } = this.state;
     
    return (
      //  notificationList?
        <div className="general-setting">

          { isAddSystemNotificationModalOpen ?
              <AddSystemNotificationModal
                  isAddSystemNotificationModalOpen={isAddSystemNotificationModalOpen}
                  closeModal = {() => this.setState({isAddSystemNotificationModalOpen: false }) }
              />
          : null 
          }

          { isEditSystemNotificationModalOpen ?
              notificationListData.map((editData) => (
                <EditSystemNotificationModal
                //  editSystemNotification = {editSystemNotification}
                  id={editData._id}
                  title={editData.title}
                  description={editData.description}
                  expdate={editData.expDate}
                  isEditSystemNotificationModalOpen={isEditSystemNotificationModalOpen}
                  closeModal = {() => this.setState({isEditSystemNotificationModalOpen: false }) }
              />
              ))
          : null 
          }

          { isDeleteSystemNotificationModalOpen ?
              <DeleteSystemNotificationModal
                  selectedNotification={ selectedNotification }
                  isDeleteSystemNotificationModalOpen={isDeleteSystemNotificationModalOpen}
                  closeModal = {() => this.setState({isDeleteSystemNotificationModalOpen: false }) }
              />
          : null 
          }
        
        <Button icon='plus' title={"Add New System Notification"} className="clr-green" onClick={this.openAddSysNotification}/>

        {( 
          <Card>
            <Card.Header>
              System Notifications
              <Label size="mini" className="mar_lr_5"> {notificationCount}
              </Label>
            </Card.Header>

            <table className="ui celled selectable table semantic-table sortable table mar_0">
              <thead className="">
                <tr className="table-header">
                  <th className="left aligned three wide table-cell-header null">
                      <div className="FilterHeader">
                        <div className="float-left"><i aria-hidden="true" className="sort icon opacity-2"></i>Title</div>
                      </div>
                  </th>
                  <th className="left aligned three wide table-cell-header null">
                      <div className="FilterHeader">
                        <div className="float-left"><i aria-hidden="true" className="sort icon opacity-2"></i>Description</div>
                      </div>
                  </th>
                  <th className="left aligned three wide table-cell-header null">
                      <div className="FilterHeader">
                        <div className="float-left"><i aria-hidden="true" className="sort icon opacity-2"></i>Created On</div>
                      </div>
                  </th>
                  <th className="left aligned three wide table-cell-header null">
                      <div className="FilterHeader">
                        <div className="float-left"><i aria-hidden="true" className="sort icon opacity-2"></i>Expiry Date</div>
                      </div>
                  </th>
                  <th className="left aligned three wide table-cell-header null">
                      <div className="FilterHeader">
                        <div className="float-left"><i aria-hidden="true" className="sort icon opacity-2"></i>Status</div>
                      </div>
                  </th>
                  <th className="left aligned three wide table-cell-header null">
                      
                  </th>

                </tr>
              </thead>
              <tbody className="table-body">
                {notificationListData.map ((notificationRecord, idx) => {
                  return (
                    <tr key={idx} data-name={notificationRecord._id} className="table-row">
                        <td className="collapsing pad_10">{notificationRecord.title}</td>
                        <td className="collapsing pad_10">{notificationRecord.description}</td>
                        <td className="collapsing pad_10"><MomentDate date={notificationRecord.createdAt}/>
                        {/* <Labels text={MomentDateAndTime(notificationRecord.createdAt)} /> */}
                        </td>
                        <td className="collapsing pad_10"><MomentDate date={notificationRecord.expDate}/></td>
                        <td className="collapsing pad_10"><span className="clr-error-green">Active</span></td>
                        <td className="collapsing pad_10">
                          <Button title={"Edit"} circular icon='pencil' onClick={(e) => this.openEditSysNotification(e, notificationRecord)}></Button>
                          <Button title={"Delete"} circular icon='trash' onClick={(e) => this.openDeleteSysNotification(e, notificationRecord)}></Button>
                        </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>

          </Card>
       
          // <Container fluid className="pad_40">
          //   <div className="text-center">
          //     <h1 className="ff_b">No System Notification configured currently</h1>
          //     {/* <Button onClick={this.viewPlans} primary>Upgrade Plans</Button> */}
          //   </div>
          // </Container>
        )}
        </div>
      //  : null
    );
  }
}

export default withRouter(SystemNotification);